import { Directive, Input } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[UpdatePaginationMatTab]',
})
export class UpdatePaginationMatTabDirective {

  @Input('UpdatePaginationMatTab') matTabGroup: any;

  constructor() {
    setTimeout(() => {
      this.matTabGroup._tabHeader.updatePagination();
    });
  }

}
